import {useCallback, useState} from "react";
import ProjectUtils from "../utils/project-utils.js";

const isEmptyValue = (value) => {
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === "string") return value.trim() === "";

    return value === null || value === undefined;
};

const focusField = (field) => {
    const reference = field.reference?.current ?? field.reference;
    const target = reference?.focus ? reference : document.getElementById(field.id);

    target?.focus?.();
};

export const useRequiredFields = () => {
    const [invalidFieldIds, setInvalidFieldIds] = useState([]);

    const clearRequiredFieldError = useCallback((id, value, isValid) => {
        const fieldIsValid = isValid ?? !isEmptyValue(value);

        if (!fieldIsValid) return;

        setInvalidFieldIds((currentIds) => currentIds.filter((currentId) => currentId !== id));
    }, []);

    const validateRequiredFields = useCallback((fields) => {
        const invalidFields = fields.filter((field) => {
            if (field.required === false) return false;
            if (typeof field.isValid === "function") return !field.isValid();

            return isEmptyValue(field.value);
        });

        if (!invalidFields.length) {
            setInvalidFieldIds([]);
            return true;
        }

        setInvalidFieldIds(invalidFields.map((field) => field.id));

        ProjectUtils.swalErrorMessage("", "Preencha os campos obrigatórios.", "OK", false, "Não", () => {
            const firstInvalidField = invalidFields[0];

            Promise.resolve(firstInvalidField.activate?.()).finally(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => focusField(firstInvalidField));
                });
            });
        });

        return false;
    }, []);

    const getRequiredFieldProps = useCallback((id, required = true) => ({
        required,
        invalid: required && invalidFieldIds.includes(id),
    }), [invalidFieldIds]);

    return {
        clearRequiredFieldError,
        getRequiredFieldProps,
        invalidFieldIds,
        validateRequiredFields,
    };
};